"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loader_1 = __importDefault(require("./Loader"));
var lodash_1 = require("lodash");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Button = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, className = _a.className, onClick = _a.onClick, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, loading = _a.loading;
    var handleClick = function (e) {
        !loading && lodash_1.isFunction(onClick) && onClick(e);
    };
    return (react_1.default.createElement("button", { disabled: disabled, className: classnames_1.default(styles_module_scss_1.default.btn, className, loading && styles_module_scss_1.default.btn_loading, variant && styles_module_scss_1.default[variant]), onClick: handleClick, type: type },
        children,
        loading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.loader_box },
            react_1.default.createElement(Loader_1.default, null)))));
};
exports.default = Button;
